<template>
  <div class="login">
    <div class=" m-auto abs" style="width:900px;height: 500px;left:50%;top:50%;transform:translate(-50%,-50%)">
      <div class="flex">
        <div style="width:500px;background:rgba(50,50,50,0.15)">
          <div class="ml-50 mt-80 pb-100">
            <div>
              <img class="w-100 h-100" src="https://caichendaizhang.oss-cn-shenzhen.aliyuncs.com/cfovip/logo.png" alt="">
              <span class="fs-28 c-f mt-40 ml-20" style="vertical-align:bottom;">欢迎登录</span>
              <i class="el-icon-right fs-30 fw-b c-f" style="vertical-align:bottom"></i>
            </div>
            <div style="border-top: 1px solid #fff;width: 360px" class="mt-20"></div>
            <p class="fs-34 mt-10 c-f">振农学习平台</p>
          </div>
          
        </div>
        <div class="flex-1 bg-f" >
          <el-form style="width: 340px" class="m-auto mt-80" ref="form" :form="form"  auto-complete="on">
            <el-form-item  prop="phoneNumber">
              <el-input  v-model="form.phoneNumber" class="id" placeholder="请输入手机号码"  auto-complete="on">
                <img slot="prefix" height="18" class="mlr-5 d-b pt-10" src="https://caichendaizhang.oss-cn-shenzhen.aliyuncs.com/loginPage/icon-7.png"/>
                <el-button v-if="loginMode === 'code'" slot="append" @click="getPhoneCode">获取验证码 <span v-if="codeCountdown">({{codeCountdown}})</span> </el-button>
              </el-input>
            </el-form-item>
            <el-form-item  class="mt-20" prop="password">
              <el-input  v-model="form.password" type="password" class="pwd"   show-password :placeholder="loginMode === 'code' ? '请输入验证码' : '请输入密码'"  auto-complete="on" >
                <img slot="prefix" height="18" class="mlr-5" src="https://caichendaizhang.oss-cn-shenzhen.aliyuncs.com/loginPage/icon-8.png"/>
              </el-input>
            </el-form-item>
            <el-form-item class="mt-20">
              <el-button class="w-full" type="primary" @click="handleLogin">登录</el-button>
              <p class=" ta-c">
                <!-- <span class="pwd-login c-pointer" v-show="loginMode === 'code'" @click="changeLoginMode('pwd')">密码登录</span> -->
                <!-- <span class="pwd-login c-pointer" v-show="loginMode === 'pwd'" @click="changeLoginMode('code')">验证码登录</span> -->
              </p>
              
              <p class="mt-20 lh-20  ta-c" style="color: #F56C6C">如有问题或无法登录</p>
              <p class="lh-20 ta-c" style="color: #F56C6C">请用微信扫描下方二维码联系客服</p>
            </el-form-item>
          </el-form>
        </div>
      </div>
      
      <div class="mt-100">
        <img class="d-b m-auto  w-100" src="https://caichendaizhang.oss-cn-shenzhen.aliyuncs.com/miniStudyPlatform/mpCode.jpg" alt="">
        <p class="fs-14 ta-c c-f mt-10">进入小程序，点击底部“客服”按钮，联系客服</p>
      </div>
    </div>
    <el-dialog :visible.sync="idcardBindState" title="身份证号绑定" width="550px">
        <p class="fs-16">
          检测到当前手机号码没有匹配课程，如需匹配课程请输入身份证号码，身份证号码匹配成功后，
          <span style="color: #F56C6C;">当前手机号码（{{form.phoneNumber}}）将作为网页端及小程序端获取课程的账号</span>，
          建议您使用常用微信所绑定的手机号码，该操作<span style="color: #F56C6C;">只能操作一次</span> ，请谨慎操作。 
        </p>
        <el-input class="mt-20 w-400 fs-18" placeholder="请输入身份证号" v-model="idcard">
           <el-button slot="append" class="fs-14" @click="dataBind">匹配课程</el-button>
        </el-input>
      </el-dialog>
  </div>
</template>
<script>
// import {
//   Req_Login
// // } from '@/ajax/login'
// import JsEncrypt from 'jsencrypt'
// const encruption = function (pwd) {
//   const encrypt = new JsEncrypt()
//   encrypt.setPublicKey('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgBEOoiPWvS+iCJ7tLbq9d3/ssoB4K4PsfTqqjG22E+59CxvfETSoLOL8UERJPeCRLnM6kfAkmQi5/xqmAbqyMaAVoINRCAHEkGJxwA6rxXCmdgspfKIwHzWlmOj8BYH09uLtdbWS0CwZ1sFtoI+sHp200lvMyq+p6gjilh5/kbJa/YftXAyZAc4hIP0b+jIATYuB5Z1JNjCJMrSRYqnqZEMluTImi7+W+3bQNcex/agRkwqY44RXxiykJEpXFtgeteDGePr1GPi8KMQ9gzKzFj5lb0ih3A4LFgVoyHvDGaeeFoT82AXch/Mt081v9kD5Ce7JXedopYLOvZ2WK7kpiwIDAQAB')
//   return encrypt.encrypt(pwd)
// }

import {
  Req_GetPhoneCode,
  Req_Login,
  Req_DataMerge
} from '@/ajax/account'
import {mapMutations} from 'vuex'


let timer = null
import {
  encruption
} from '@/util'
export default {
  data() {
    return {
      idcardBindState:false,
      idcard:'',
      codeCountdown: 0,
      form: {
        phoneNumber: '',
        password: ''
      },
      userInfo: {},
      loginMode: 'pwd'
    }
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    changeLoginMode(mode) {
      this.loginMode = mode
    },
    dataBind() {
      Req_DataMerge({
        userId: this.userInfo.userId,
        idCard: this.idcard
      }).then(res => {
        this.onLoginSuc()
      }).catch(err => this.$catchErr(err))
    },
    getPhoneCode() {
      Req_GetPhoneCode({
        phoneNumber: this.form.phoneNumber
      }).then(res => {
        this.form.password = res
        this.codeCountdown = 60
        clearInterval(timer)
        this.setCodeInterval()
      }).catch(err =>{
         clearInterval(timer)
        this.codeCountdown = 0
         this.$catchErr(err)
      })
    },
    setCodeInterval() {
      timer = setInterval(() => {
        this.codeCountdown --
        if(this.codeCountdown === 0) {
          clearInterval(timer)
        }
        
      },1000)
    },
    handleLogin() {
      const {phoneNumber,password} = this.form
      Req_Login({
        phoneNumber,
        password: encruption(password)
      }).then(res => {
        //查看是否存在机构
        this.userInfo = res
        clearInterval(timer)
         
        if(res.trainingUnitId) {
          this.onLoginSuc()
        } else {
          this.idcardBindState = true
        }
      
      }).catch(err => this.$catchErr(err))
    },
    onLoginSuc() {
      this.setUserInfo(this.userInfo)
      localStorage.setItem('userId', this.userInfo.userId)
      this.$message.success('登录成功')
      this.$router.push('/lesson')
    },
  },
  beforeDestroy() {
    clearInterval(timer)
  }
}
</script>
<style lang="less" scoped>
.login {
    background: url("https://caichendaizhang.oss-cn-shenzhen.aliyuncs.com/cfovip/loginBg.png") ;
    background-position: center; 
    background-repeat:no-repeat;
    background-size:cover;
    height: calc(100vh);
    overflow: hidden;
}
.pwd-login {
  color: #666;
  text-decoration: underline;
}
.pwd-login:hover {
  color: #333
}

</style>


// WEBPACK FOOTER //
// src/pages/Login.vue